var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPsidebaricon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65579",
    "data-name": "Grupo 65579",
    transform: "translate(-24 -20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15524",
    "data-name": "Ret\\xE2ngulo 15524",
    width: 24,
    height: 2,
    transform: "translate(24 20)",
    fill: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15525",
    "data-name": "Ret\\xE2ngulo 15525",
    width: 24,
    height: 2,
    transform: "translate(24 28)",
    fill: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15526",
    "data-name": "Ret\\xE2ngulo 15526",
    width: 12,
    height: 2,
    transform: "translate(24 36)",
    fill: "#1b1b1b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPsidebaricon);
export default __webpack_public_path__ + "static/media/LPsidebaricon.891d41f4e21c19de6b12f43b9c3be55e.svg";
export { ForwardRef as ReactComponent };